const mockedPayslipText = 'This is a testing Payslip';
export const mockedPayslipFile = new Blob([mockedPayslipText], {
  type: 'text/plain',
});
